<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormImpuesto" role="form" method="post" autocomplete="off" onSubmit="return false">
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Nombre">Nombre</label>
							<input type="text" v-model="objImpuesto.Nombre" class="form-control" id="Nombre" placeholder="Ingresar Nombre" readonly/>
							<CValidation v-if="this.errorvalidacion.Nombre" :Mensaje="'*'+errorvalidacion.Nombre[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Impuesto">Impuesto %</label>
							<input type="text" v-model="objImpuesto.Impuesto" @input="$onlyNums($event,objImpuesto,'Impuesto');CalcularValor()" class="form-control" id="Impuesto" placeholder="Ingresar Impuesto" />
							<CValidation v-if="this.errorvalidacion.Impuesto" :Mensaje="'*'+errorvalidacion.Impuesto[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="ValorImpuesto">Valor Impuesto</label>
							<input type="text" v-model="objImpuesto.ValorImpuesto" class="form-control" id="ValorImpuesto" placeholder="Ingresar Valor Impuesto" readonly/>
							<CValidation v-if="this.errorvalidacion.ValorImpuesto" :Mensaje="'*'+errorvalidacion.ValorImpuesto[0]"/>
						</div>
					</div>
					
											
					<br>
				
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>

export default {
    name: 'FormImpuesto',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objImpuesto: {
				IdImpuesto: 0,
				Nombre: '',
				Impuesto: '',
				ValorImpuesto: 0,
				IdEmpresa: 0,
				IdSucursal: 0,
				
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			//masks:{ input: 'YYYY-MM-DD'}, // quitar sino lleva fecha
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;

			if(this.objImpuesto.IdImpuesto == 0) {
				await this.$http.post(
					'impuestos',this.objImpuesto
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			} else {
				await this.$http.put(
					'impuestos/'+this.objImpuesto.IdImpuesto,
					this.objImpuesto
				).then((res)=>{                 
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			}
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "impuestos/"+this.objImpuesto.IdImpuesto
            ).then((res) => {
                this.objImpuesto = res.data.data;

            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objImpuesto = {
				IdImpuesto: 0,
				Nombre: '',
				Impuesto: '',
				ValorImpuesto: 0,
				IdEmpresa: 0,
				IdSucursal: 0,
				
            }
            this.errorvalidacion = [];
        },
        CalcularValor()
        {
            let Impuesto = 0;
            if(this.objImpuesto.Impuesto!=''){
                Impuesto = parseFloat(this.objImpuesto.Impuesto);
                Impuesto = parseFloat(Impuesto/100);
                Impuesto = (isNaN(Impuesto)) ? 0 : Impuesto;
            }

            this.objImpuesto.ValorImpuesto = Impuesto;
        }
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
                
            if (Id!='') 
            {
                this.objImpuesto.IdImpuesto = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    }
}
</script>
